import { createSlice, PayloadAction } from '@reduxjs/toolkit'
 
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { Extent } from 'ol/extent';
import { getPadding } from '../../util';
import { Layer as LayerControl } from '../../../bgis/ol/control';
import { toggleClass } from '../../../bgis/util/dom';
import {   mapState  } from '../../map';
import { Geometry } from 'ol/geom';
import { MessobjectType } from '../../interfaces';
import {OpenMapOptions} from '../../interfaces';
import RenderFeature from 'ol/render/Feature';

/* autria extent limit */
proj4.defs(
  'EPSG:31287',
  '+proj=lcc +lat_1=49 +lat_2=46 +lat_0=47.5 +lon_0=13.33333333333333 +x_0=400000 +y_0=400000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs',
);
register(proj4); /* register the projection in ol core */


// Define a type for the slice state
export interface MapState {
  /* map */
  isDisplayed: boolean;
  preFiltered?: Record<MessobjectType,string[]>,
  maxFitZoom: number,
  selectedBackgroundLayer:'BG'|'BO'|'BN',
  isOpenMapCalled: boolean,
  openMapOptions: OpenMapOptions | undefined
 
}

const baseMapLayerControl = new LayerControl();
baseMapLayerControl.addEventListener("click", () => {
  toggleClass('bgis-basemap', 'show');
});

// Initial search state
const initialState: MapState = {
  
  selectedBackgroundLayer:'BG',
  isDisplayed: false,
  preFiltered: undefined, // nothing is preFiltered
  maxFitZoom: 17,
  isOpenMapCalled:false,
  openMapOptions: undefined
}

export const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    toggle: (state) => {
      state.isDisplayed = state.isDisplayed === true ? false : true;
    },
    
    tearDownMap: (state) => {
      mapState.h2oMap?.setTarget(undefined);
      state.isDisplayed = false;
      console.log("tear down executed");
    },
    setIsOpenMapCalled: (state, action: PayloadAction<boolean>) => {
      state.isOpenMapCalled=action.payload;
    },
    setOpenMapOptions: (state, action:PayloadAction<OpenMapOptions>) => {
      state.openMapOptions = action.payload;
    },
    syncBackMap: (state) => {
      // do sync back
      tearDownMap();
    },
    createMap: (state) => {
     // mapState.h2oMap = createMap();
    },
    setIsDisplayed: (state, action: PayloadAction<boolean>) => {
      state.isDisplayed = action.payload;
      console.log("set is dsiplayed "+state.isDisplayed );
    },
    setPrefiltered: (state, action: PayloadAction<Record<MessobjectType,string[]> | undefined>) => {
      state.preFiltered = action.payload  ;
    },
    /**
     * Zooms to the given extent (if any).
     * @param state The map state.
     * @param action The extent (if any).
     */
    zoomTo: (state, action: PayloadAction<Extent | Geometry   | undefined>) => {
      if (action.payload ) {
        let extent = action.payload instanceof Geometry ? action.payload.getExtent() : action.payload;
        if(extent[0]!==Infinity) {
        mapState.h2oMap.getView()
          .fit(action.payload instanceof Geometry ? action.payload.getExtent() : action.payload , { duration: 1000, maxZoom: state.maxFitZoom, padding: getPadding(mapState.h2oMap.getSize()) });
        }
      
        }
    },
  },
});

export const { toggle,   createMap, tearDownMap, zoomTo, setOpenMapOptions, setPrefiltered, setIsDisplayed } = mapSlice.actions